import PageManager from './page-manager';

export default class SiteMap extends PageManager {}



// WEBPACK FOOTER //
// ./assets/js/theme/sitemap.js